import {Link} from "react-router-dom";
import {Header} from "../components/Header";
import {useEffect, useState} from "react";

import {Modal} from "../components/Modal";
import {IoMdClose} from "react-icons/io";

export const YogeshwariMantropchar = () => {
    const mantropcharData = [
        {
            title: "श्री योगेश्वरी सहस्र नाम",
            img: "/other_imgs/thumbnail-dharmik-mantropchar2.png",
            url: "https://www.youtube.com/embed/quESXZjlTQ4",
        },
        {
            title: "अष्टक",
            img: "/other_imgs/thumbnail-dharmik-mantropchar2.png",
            url: "https://www.youtube.com/embed/oWFdZ21xb7c",
        },
        {
            title: "अथ श्री देव्यष्टोतरशत नामावली",
            img: "/other_imgs/thumbnail-dharmik-mantropchar2.png",
            url: "https://www.youtube.com/embed/SLH53TvlfFE",
        },
        {
            title: "अथ श्री चतुःषष्ठी योगिनीनाम",
            img: "/other_imgs/thumbnail-dharmik-mantropchar2.png",
            url: "https://www.youtube.com/embed/idAyIUsL7QI",
        },
        {
            title: "श्री देव्यपराधक्षमापनस्तोत्रम्",
            img: "/other_imgs/thumbnail-dharmik-mantropchar2.png",
            url: "https://www.youtube.com/embed/FSvclpWj68E",
        },
        {
            title: "श्री गुरुस्वामीसमर्थ",
            img: "/other_imgs/thumbnail-dharmik-mantropchar2.png",
            url: "https://www.youtube.com/embed/-gCa41yXYs4",
        },
        {
            title: "महामंत्र",
            img: "/other_imgs/thumbnail-dharmik-mantropchar2.png",
            url: "https://www.youtube.com/embed/EnG1i5pVBAc",
        },
        {
            title: "ध्यानमंत्र",
            img: "/other_imgs/thumbnail-dharmik-mantropchar2.png",
            url: "https://www.youtube.com/embed/-fpfwjGxCsE",
        },
        {
            title: "यजुर्मत्र",
            img: "/other_imgs/thumbnail-dharmik-mantropchar2.png",
            url: "https://www.youtube.com/embed/Feo9HllSaEk",
        },
    ];

    const [isModalOpen, setModalOpen] = useState(false);
    const [videoUrl, setVideoUrl] = useState("");
    const [modalTitle, setModalTitle] = useState("");

    const openModal = (url, title) => {
        if (url) {
            setVideoUrl(url);
            setModalTitle(title);
            setModalOpen(true);
        } else {
            alert("Video not available");
        }
    };

    const closeModal = () => {
        setModalOpen(false);
        setVideoUrl("");
        setModalTitle("");
    };

    useEffect(() => {
        // Scroll to top when the page is rendered
        window.scrollTo(0, 0);
    }, []);
    return (
        <>

            <div className="w-full bg-white  flex flex-col items-center justify-center">
                <Header/>
                <img
                    src="/other_imgs/banner-dharmik-mantropchar-inside.jpg"
                    alt="Information Banner"
                    className="w-full object-cover shadow-lg"
                />
            </div>

            <div className=" md:max-w-[1400px] md:mx-auto">
                <ul className="grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-2 my-10 md:mx-10 mx-2 ">
                    {mantropcharData.map((mantropchar, index) => (
                        <li
                            key={index}
                            onClick={() => openModal(mantropchar.url, mantropchar.title)}
                            className="flex items-center border-2 bg-[#AE0000] shadow-lg rounded-lg p-6
                        bg-whtie h-[130px] w-[100%] md:max-w-[450px] md:mx-12 hover:scale-105 transition-all duration-300"
                        >
                            <Link to={mantropchar.link} className="flex items-center w-full">
                                <img
                                    src={mantropchar.img}
                                    alt={mantropchar.title}
                                    className="w-28 h-28 object-cover rounded-md mr-10"
                                />
                                <div className="text-lg font-semibold text-white ">
                                    {mantropchar.title}
                                </div>
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
            <Modal isOpen={isModalOpen} onClose={closeModal}>
                <div className="relative w-full h-full p-4 bg-white rounded-lg">
                    <button
                        className="absolute top-2 right-2 text-gray-700 rounded-full p-2 shadow-md "
                        onClick={closeModal}
                    >
                        <IoMdClose/>
                    </button>
                    <h2 className="text-center text-2xl font-bold text-red-600 mb-4">
                        {modalTitle}
                    </h2>
                    {videoUrl ? (
                        <iframe
                            width="100%"
                            height="350"
                            src={videoUrl}
                            title="YouTube video"
                            frameBorder="0"
                            className="rounded-lg"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    ) : (
                        <div className="text-center text-lg font-semibold">
                            Video not available
                        </div>
                    )}
                </div>
            </Modal>
        </>
    );
};
